module.exports = __webpack_public_path__ + "img/award-bg-ar.f2b092b5.png";